import selectComponent from 'utilities/select-component'
import 'waypoints/lib/jquery.waypoints'

export default class List {

    constructor(element) {
        this.$list = selectComponent(element)
        this.$items = this.$list.elements.item

        this.addInview()
    }

    addInview() {
        this.$items.each((index, element) => {
            const item = new Waypoint({
                element: element,
                handler: (direction) => {
                    $(element).addClass('-inview')
                },
                offset: '85%'
            })
        })
    }
}